import React, { useRef, useEffect } from 'react';
import { Box, Typography, InputBase } from '@mui/material';

export const IndicationField = React.forwardRef(({
  title = '',
  amount,
  value,
  onChange,
  errors,
  disabled = false,
  validChars = 'A-Za-z0-9' }) => {
  const inputsRef = useRef([]);

  useEffect(() => {
    if (value.length > amount) {
      onChange(value.slice(0, amount));
    }
  }, [value, amount, onChange]);

  const handleChange = (index, char) => {
    const regex = new RegExp(`^[${validChars}]$`, 'i');
    if (!regex.test(char) && char !== '') return;

    const newValue = value.split('');
    newValue[index] = char;
    const updated = newValue.join('').padEnd(amount, '');
    onChange(updated);

    if (char && index < amount - 1 && inputsRef.current[index + 1]) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !value[index] && index > 0 && inputsRef.current[index - 1]) {
      inputsRef.current[index - 1].focus();
    }
  };

  return (
    <Box
      p="10px 15px"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#F4F4F4',
        borderRadius: "8px",
        flexDirection: {
          xs: 'column',
          sm: 'row',
          md: 'row',
          lg: 'row',
          xl: 'row',
        },
      }}
    >
      <Typography sx={{ color: '#333333', font: "normal normal normal 13px/30px Roboto" }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {Array.from({ length: amount }).map((_, index) => (
          <InputBase
            key={index}
            inputRef={el => inputsRef.current[index] = el}
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: 'center',
                width: 28,
                height: 19,
                border: '1px solid #C4C4C4',
                borderRadius: 6,
                backgroundColor: '#fff',
                font: "normal normal bold 16px/30px Roboto",
                color: "#333333"
              }
            }}
            error={errors?.status ? errors?.message : ''}
            disabled={disabled}
            value={value[index] || ''}
            onChange={e => handleChange(index, e.target.value)}
            onKeyDown={e => handleKeyDown(index, e)}
          />
        ))}
      </Box>
    </Box>
  );
});
